import { useQuery } from '@tanstack/react-query';
import { folderService } from '../services/folderService';
import type { FolderQueryParams } from '../types';

export function useFolders(params: FolderQueryParams = {}) {
  return useQuery({
    queryKey: ['folders', params],
    queryFn: () => folderService.getFolders(params),
  });
}
